<script>
    import { onMount } from "svelte";
    import { cuenta, documentos } from "./store.js";
    import axios from "axios";

    onMount(async () => {
        await updateDocumentos();
    });
    async function agregarDocumento(event) {
        //ejemplo
        const newTodo = {
            text: newTodoText,
            complete: false,
            createdAt: new Date().toISOString(),
        };
        const addition = await db.post(newTodo);
        if (addition.ok) {
            await updateTodos();
        }
        newTodoText = "";
    }
    async function eliminarDocumento(event) {
        const { todo: todoToRemove } = event.detail;
        const removal = await db.remove(todoToRemove);
        if (removal.ok) {
            // For removal, we can just update the local state instead of reloading everything from PouchDB,
            // since we no longer care about the doc’s revision.
            $documentos = $documentos.filter((todo) => {
                return todo._id !== todoToRemove._id;
            });
        }
    }
    async function acualizarDocumento(event) {
        const { todo } = event.detail;
        const update = await db.put(todo);
        if (update.ok) {
            await updateDocumentos();
        }
    }
    async function updateDocumentos() {
        const allDocs = await db.allDocs({
            include_docs: true,
        });
        $documentos = allDocs.rows.map((row) => row.doc);
    }
    async function sync() {
        const replication = PouchDB.sync(
            "db",
            "https://vps-1858514-x.dattaweb.com/recetas",
            {
                live: true,
                retry: true,
                auth: {
                    username: $cuenta.user,
                    password: $cuenta.pass,
                },
            }
        )
            .on("change", async function (info) {
                await updateDocumentos();
            })
            .on("error", function (err) {
                console.log("Replication error:", err);
            });
    }
    function setCuenta(
        user,
        pass,
        nombre,
        pago,
        titulo,
        matricula,
        firma,
        rev
    ) {
        $cuenta = {
            user: user,
            pass: pass,
            pago: pago,
            nombre: nombre,
            titulo: titulo,
            matricula: matricula,
            firma: firma,
            _rev: rev,
        };
    }
    export async function login(user, pass) {
        return axios
            .get(`https://vps-1858514-x.dattaweb.com/recetas/cuentas:${user}`, {
                auth: { username: user, password: pass },
            })
            .then(async (res) => {
                console.log(res);
                setCuenta(
                    user,
                    pass,
                    res.data.nombre,
                    res.data.pago,
                    res.data.titulo,
                    res.data.matricula,
                    res.data.firma,
                    res.data._rev
                );
                await sync();
                return {
                    status: 200,
                    valor: "/home",
                };
            })
            .catch(async (err) => {
                if (err.response != undefined) {
                    if (err.response.status == 404) {
                        setCuenta(user, pass, "", true, "", "", "", "", "");
                        await sync();
                        return {
                            status: 404,
                            valor: "/primera/vez",
                        };
                    } else {
                        console.log("no registrado");
                        return {
                            status: 404,
                            valor: "/",
                        };
                    }
                }
            });
    }
    export async function nuevaCuenta(
        user,
        pass,
        nombre,
        titulo,
        matricula,
        firma
    ) {
        const newDoc = {
            _id: `cuentas:${user}`,
            user: user,
            pass: pass,
            nombre: nombre,
            titulo: titulo,
            matricula: matricula,
            firma: firma,
            pago: true,
            meses: 3,
            pago: new Date().toISOString(),
            creado: new Date().toISOString(),
        };
        const addition = await db.post(newDoc);
        if (addition.ok) {
            await updateDocumentos();
        }
    }
    export async function actualizarCuenta(
        nombre,
        titulo,
        matricula,
        firma
    ){
        const newDoc = {
            _rev: $cuenta._rev,
            _id: `cuentas:${$cuenta.user}`,
            user: $cuenta.user,
            pass: $cuenta.pass,
            nombre: nombre,
            titulo: titulo,
            matricula: matricula,
            firma: firma
        };
        const update = await db.put(newDoc);
        if (update.ok) {
            setCuenta(newDoc.user,newDoc.pass,newDoc.nombre,newDoc.titulo,newDoc.matricula,newDoc.firma);
            await updateDocumentos();
            return {
                status: 200,
                valor:"/home"
            };
        } else {
            return {
                status: 400,
                valor:"/home"
            }
        }
    }
</script>

